// 设备管理接口
import request from '@/utils/request'

export const saveOrUpdate = (params: any) =>
  request({
    url: '/topicexpert/updateOpinionAndScore',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const getActiveList = (params: any) =>
  request({
    url: 'activity/getActivity',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
export const getOptionInfo = (params: any) =>
  request({
    url: '/topicexpert/expertGetOpinionAndScore',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/json'
    }
  })
